// extracted by mini-css-extract-plugin
export default {"review":"styles_review__9XV2k","block":"styles_block__wv0Kx","ratings":"styles_ratings__1wIjg","rating":"styles_rating__NR8Ji"};